import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';

// -----------------------------------------------------------
// Bilalsadasub logo — uses the real /logo_icon.webp from the Flutter assets.
// `sx` accepts any MUI sx props (mostly width/height).
// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const img = (
    <Box
      component="img"
      src="/logo_icon.webp"
      alt="Bilalsadasub"
      sx={{ width: 40, height: 40, objectFit: 'contain', ...sx }}
    />
  );

  if (disabledLink) return img;
  return <RouterLink to="/">{img}</RouterLink>;
}
